import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';
import RiskDetail from '../../components/Risks/RiskDetail';
import riskService from '../../services/riskService';
import './RiskDetailPage.css';

const RiskDetailPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [risk, setRisk] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadRisk();
  }, [id]);

  const loadRisk = async () => {
    try {
      setLoading(true);
      const data = await riskService.getById(id);
      setRisk(data.data);
    } catch (error) {
      console.error('Error loading risk:', error);
      alert('Failed to load risk');
      navigate('/app/risks');
    } finally {
      setLoading(false);
    }
  };

  const handleBack = () => {
    navigate('/app/risks');
  };

  const handleEdit = () => {
    navigate(`/app/risks/${id}/edit`);
  };

  const handleDelete = async () => {
    if (window.confirm('Are you sure you want to delete this risk?')) {
      try {
        await riskService.delete(id);
        navigate('/app/risks');
      } catch (error) {
        console.error('Error deleting risk:', error);
        alert('Failed to delete risk');
      }
    }
  };

  if (loading) {
    return (
      <div className="risk-detail-page">
        <div className="risk-detail-page-loading">Loading risk...</div>
      </div>
    );
  }

  return (
    <div className="risk-detail-page">
      <div className="risk-detail-page-header">
        <button onClick={handleBack} className="btn-back">
          <FiArrowLeft />
          Back to Risks
        </button>
      </div>
      <RiskDetail 
        risk={risk} 
        onEdit={handleEdit}
        onDelete={handleDelete}
      />
    </div>
  );
};

export default RiskDetailPage;

